import { QueryClientProvider } from '@tanstack/react-query';
import KeycloakAuthentication from 'components/KeycloakAuthentication';
import {
  tanstackQueryClient,
  userManagerConfig,
} from 'components/KeycloakAuthentication/constants';
import { onSigninCallback } from 'components/KeycloakAuthentication/helpers';
import { store } from 'lib/stores';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { Provider } from 'react-redux';
import App from './App';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import '@fontsource/roboto-mono/400.css';
import 'nprogress/nprogress.css';
import 'styles/global.scss';
import { USE_SSO } from 'lib/constants';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <QueryClientProvider client={tanstackQueryClient}>
      {USE_SSO ? (
        <AuthProvider
          userManager={userManagerConfig}
          onSigninCallback={onSigninCallback}
        >
          <KeycloakAuthentication>
            <App />
          </KeycloakAuthentication>
        </AuthProvider>
      ) : (
        <App />
      )}
    </QueryClientProvider>
  </Provider>
);
